import "./Modal.scss";

import {FmlxDropdown, FmlxModal} from 'fmlx-common-ui';
import {FMLX_BUTTON} from '../../../const/FmlxComponentEnum';
import {useDispatch, useSelector} from 'react-redux';
import {confirmRemoveTeam} from '../../../stores/business/teamAssignmentBusiness';
import {setShowModalTeam} from '../../../stores/actions/teamAssignmentAction';
import {useEffect, useState} from 'react';
import {callAPI} from '../../../api/rest/callApi';
import {API_REVIEW_PERIOD} from '../../../const/Api';

const ModalOutDate = () => {
  const dispatch = useDispatch();
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [periods, setPeriods] = useState([]);
  const {showModalTeam} = useSelector(state => ({
    showModalTeam: state.teamAssignmentState.showModalTeam
  }));

  useEffect(() => {
    const fetchPeriods = async () => {
      const res = await callAPI({
        method: 'GET',
        url: API_REVIEW_PERIOD
      });

      if (res.data) {
        const formattedPeriods = res.data.data.map(period => ({
          id: period.id,
          text: period.period,
          startDate: period.startDate,
          endDate: period.endDate
        }));
        setPeriods(formattedPeriods);
      }
    };

    if (showModalTeam) {
      fetchPeriods();
    }
  }, [showModalTeam]);

  const handleConfirmRemove = () => {
    const selectedPeriodData = periods.find(period => period.id === selectedPeriod);
    if (selectedPeriodData) {
      dispatch(confirmRemoveTeam(selectedPeriodData))
    }
  };

  const handlePeriodChange = (selectedId) => {
    setSelectedPeriod(selectedId);
  };

  if (!showModalTeam) {
    return null;
  }

  return (
    <div className='modal-container'>
      <FmlxModal
        id='modal-out-date'
        open={showModalTeam}
        size="md"
        title="Please Input Out Date Of The Member?"
        onCloseClick={() => dispatch(setShowModalTeam(false))}
        primaryButton={{
          show: true,
          disabled: !selectedPeriod,
          label: 'Remove',
          type: FMLX_BUTTON.TYPE.PRIMARY,
          variant: FMLX_BUTTON.VARIANT.CONTAIN,
          onClick: handleConfirmRemove
        }}
        secondaryButton={{
          show: true,
          label: 'Cancel',
          type: FMLX_BUTTON.TYPE.BASIC,
          variant: FMLX_BUTTON.VARIANT.CONTAIN,
          onClick: () => dispatch(setShowModalTeam(false))
        }}
        tertiaryButton={{
          show: false
        }}
      >
        <div className="dropdown-modal-outdate">
          <FmlxDropdown
            items={periods}
            selectedItem={selectedPeriod}
            onChange={handlePeriodChange}
            placeholder="Select Period"
          />
        </div>
      </FmlxModal>
    </div>
  );
};

export default ModalOutDate;